import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Popup from 'reactjs-popup';
import config from '../src/config';

// Styles
import './index.css';
import './common.css';
import LearnerAssignmentReview2 from './pages/admin/LearnerAssignmentReview2';

// Routes
const LearnerRoutes = lazy(() => import('./routes/LearnerRoutes'));
const FacultyRoutes = lazy(() => import('./routes/FacultyRoutes'));
const AdminRoutes = lazy(() => import('./routes/AdminRoutes'));

// Components
const Sidebar = lazy(() => import('./components/navigation/Sidebar'));
const SidebarFaculty = lazy(() => import('./components/navigation/SidebarFaculty'));
const WidgetSidebarLearner = lazy(() => import('./components/navigation/WidgetSidebarLearner'));
const HeaderLearner = lazy(() => import('./components/navigation/HeaderLearner'));
const HeaderFaculty = lazy(() => import('./components/navigation/HeaderFaculty'));

// Pages
const Login = lazy(() => import('./pages/login/Login'));
const ChangePassword = lazy(() => import('./pages/login/ChangePassword'));
const DashboardLearner = lazy(() => import('./pages/dashboard/DashboardLearner'));
const DashboardFaculty = lazy(() => import('./pages/dashboard/DashboardFaculty'));
const WidgetDashboard = lazy(() => import('./pages/dashboard/WidgetDashboard'));
const ContentView = lazy(() => import('./pages/study-material/ContentView'));
const StudentScorecard = lazy(() => import('./pages/scorecard/StudentScorecard'));
const FacultyScorecard = lazy(() => import('./pages/scorecard/FacultyScorecard'));
const Unsubscribe = lazy(() => import('./pages/unsubscribe/Unsubscribe'));
const NoToken = lazy(() => import('./pages/login/noToken'));
const AttemptPaper = lazy(() => import('./pages/assessment/AttemptPaper'));

// Error Handling
const NotFound = lazy(() => import('./components/error/NotFound'));


const AppComponent = ({ location, loggedIn, saveLanguageWiseData, learnerprofile }) => {
  const [isErrorFound, setIsErrorFound] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorCode, setErrorCode] = useState(200);

  const previousLocation = useRef(location);

  const handleSessionTimeout = () => {
    localStorage.setItem('is_error_found', 1);
    localStorage.setItem('error_message', saveLanguageWiseData.session_expired_login_again);
    localStorage.setItem('error_code', 403);
    setIsErrorFound(true);
    setErrorMessage(saveLanguageWiseData.session_expired_login_again);
    setErrorCode(403);
  };

  useEffect(() => {
    if (localStorage.getItem('token')) {
      const timeout = setTimeout(handleSessionTimeout, config.sessionTimeOutTime);
      return () => clearTimeout(timeout);
    }
  }, [saveLanguageWiseData]);

  const isModal = !!(
    location.state &&
    location.state.modal &&
    previousLocation.current !== location
  );

  return (
    <div>
      {/* Error Popup */}
      <Popup className="iserrorfound" open={isErrorFound} closeOnDocumentClick={false}>
        <div className="connection_failed">{errorMessage}</div>
        <button onClick={() => window.location.reload()}>{saveLanguageWiseData.try_again_now}</button>
      </Popup>

      <Suspense fallback={<div className="loader"></div>}>
        <Switch location={isModal ? previousLocation.current : location}>
          {!loggedIn ? (
            <Route path="/" component={Login} exact />
          ) : (
            <>
              <Route path="/" component={WidgetDashboard} exact />
              <Route path="/learner" component={DashboardLearner} exact />
              <Route path="/faculty" component={DashboardFaculty} exact />
              <Route path="/unsubscribe" component={Unsubscribe} exact />
              <Route path="/notoken" component={NoToken} exact />
              <Route path="/learner/scorecard/:id" component={StudentScorecard} exact />
              <Route path="/faculty/scorecard/:id" component={FacultyScorecard} exact />
              <Route path="/learner/classroom/:id" component={ContentView} exact />
              <Route path="/learner/classroom/:id/:content_id" component={ContentView} exact />
              <Route path="/learner/assignment-reviews/:id" component={LearnerAssignmentReview2} exact />
              <Route path='/learner/attempt/:assessmentId' component={AttemptPaper} exact />
            </>
          )}
          <Route component={NotFound} />
        </Switch>
      </Suspense>

      <Suspense fallback={<div className="loader"></div>}>
        {learnerprofile?.role === 5 && (
          <div className="admin-dashboard">
            <AdminRoutes />
            <Sidebar />
          </div>
        )}
        {learnerprofile?.role === 3 && (
          <div className="faculty-dashboard">
            <FacultyRoutes />
            <SidebarFaculty />
            <HeaderFaculty />
          </div>
        )}
        {learnerprofile?.role === 4 && (
          <div className="learner-dashboard">
            <LearnerRoutes />
            <WidgetSidebarLearner />
            <HeaderLearner />
          </div>
        )}
      </Suspense>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loggedIn: state.commonReducer.loggedIn,
  learnerprofile: state.commonReducer.logindetails,
  saveLanguageWiseData: state.commonReducer.languageData,
});

export default connect(mapStateToProps)(AppComponent);